import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Dropdown } from '@beef/ui-kit';

import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import { getFeedbackSortBy, getFeedbackIsLoading } from 'store/ProductDetails/selectors';
import { setFeedbackSortBy } from 'store/ProductDetails/feedbackLocal/actions';
import { FeedbackSortByOptions } from 'store/ProductDetails/feedbackLocal/constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function FeedbackSortBy({ isDisabled, sortBy, onChangeSortBy, isMobile }) {
  return (
    <div className={cx('wrap', isMobile && 'mobile')}>
      <Dropdown
        onChange={onChangeSortBy}
        options={FeedbackSortByOptions}
        value={sortBy}
        disabled={isDisabled}
        className={cx(isMobile ? 'selectMobile' : '', 'dropdown')}
      />
    </div>
  );
}

FeedbackSortBy.propTypes = {
  isDisabled: PropTypes.bool,
  sortBy: PropTypes.string,
  onChangeSortBy: PropTypes.func,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  sortBy: getFeedbackSortBy(state),
  isDisabled: getFeedbackIsLoading(state),
  isMobile: isScreenBelow1004(state),
});

const mapDispatchToProps = {
  onChangeSortBy: (value) => setFeedbackSortBy({ value }),
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackSortBy);
